export { ReactComponent as Code } from './svgs/code.svg';
